module.exports = __webpack_public_path__ + "img/favorite_yes.dc6d864a.png";